import styled from 'styled-components';

export const ElementWrapper = styled.div`
  text-align: center;
  height: 36px;
  width: 36px;
  display: inline-flex;
  flex-direction: column;
`;
